<template lang="pug">
div()
  v-layout(justify-end)
      v-icon(
          v-if="hasAccess('onoffaccessTable')"
          @click="saveVisibles()"
      ) save
  v-treeview(
    v-model="lockedSelected"
    :active.sync="active"
    :open.sync="open"
    :items="toc"
    activatable
    active-class="imsuperselected"
    expand-icon="expand_more"
    item-key="vpath"
    transition
    selectable=true
    v-if="hasAccess('onoffaccessTable') || hasAccess('onoffmessageaccessTable')"
  )
    template(slot="prepend" slot-scope="{ item, open, leaf }")
      div(
        :id="getNodeId(moduleId,item)"
        @click="cleanActiveClass()"
        ).text-link
        v-clamp(
          autoresize
          :max-lines="lineNumber"
          slot="activator"
        ) {{ item ? item.name: '' }}
  v-treeview(
    :active.sync="active"
    :open.sync="open"
    :items="toc"
    activatable
    active-class="imsuperselected"
    expand-icon="expand_more"
    item-key="vpath"
    transition
    v-if="(!(hasAccess('onoffaccessTable') || hasAccess('onoffmessageaccessTable')))"
  )
    template(slot="prepend" slot-scope="{ item, open, leaf }")
      div(
        :id="getNodeId(moduleId,item)"
        @click="cleanActiveClass()"
        ).text-link
        v-clamp(
          autoresize
          :max-lines="lineNumber"
          slot="activator"
        ) {{ item ? item.name:'' }}
</template>

<script>
import VClamp from 'vue-clamp';
import { mapGetters, mapState } from 'vuex';
import treeUtils from '@/lib/treeutils';
import { content } from '@/api';
import * as types from '@/store/mutationTypes';


export default {
    name: 'CEModuleTOC',
    components: {
        VClamp
    },

    data() {
        return {
            loading: false,
            active: [],
            open: [],
            selected: [],
            lineNumber: this.$store.state.appearance.characterLimitLine
        };
    },

    props: {
        toc: Array,
        moduleId: Number,
        resetActive: Boolean
    },

    computed: {

        ...mapState({
            navigation: state => state.navigation.navigation,
        }),

        ...mapGetters({
            isAllowedTo: 'session/isAllowedTo',
            hasAccess: 'session/hasAccess'
        }),

        lockedSelected: {
            get() {
                return this.selected;
            },
            set(value) {
                if (this.hasAccess('onoffaccessTable')) {
                    this.selected = value;
                } else if (JSON.stringify(value.sort()) !==
                            JSON.stringify(this.selected.concat().sort())) {
                    alert('Policies are managed by your Administrator. Please contact them for changes.');
                    // Trigger reactivity, change back to previous selected tree view control
                    this.selected = this.selected.concat();
                }
            }
        }
    },

    // Moved to mounted, this gets called per component not per instance??
    created() {
        const { moduleId, pagePath } = this.$route.params;

        this.initExpandTwoLevels();
        // Selected Data Structure Details
        // If a parent is made false, all children are made false
        // If a parent is made true, all children are made true
        // If all children are made true, parent is made true
        // If all children are made false, parent is made false
        // If some children are made true or false, parent is made false
        // Leaf can be made true or false
        this.selected = treeUtils.flattenFilteredTreeField(this.toc[0],
            'vpath', node => node.visible || !Object.prototype.hasOwnProperty.call(node, 'visible'));
        // Only open nodes for correct module
        if (moduleId !== undefined && pagePath !== undefined) {
            if (parseInt(moduleId, 10) !== this.moduleId) return;
            const { lineage } = this.navigation[moduleId][pagePath];
            this.setActiveItem(
                pagePath,
                lineage.map(item => item.path)
            );
        }
    },

    mounted() {
    },

    watch: {
        active(pagePath) {
            this.$emit('pageSelected', {
                moduleId: this.moduleId,
                path: pagePath[0]
            });
        },

        resetActive(newValue) {
            // if (newValue) {
            //     this.active = [];
            // }
        }
    },

    methods: {
        setLoading(value) {
            this.loading = value;
            if (value) {
                this.$store.commit(types.APPEARANCE_SET_PROGRESS_CURSOR);
            } else {
                this.$store.commit(types.APPEARANCE_SET_DEFAULT_CURSOR);
            }
        },

        getNodeId(moduleId, item) {
            const path = item && item.path ? item.path.substring(0, item.path.length - 3) : '';
            return `toc-node-${moduleId}-${path}`;
        },

        isLoading() {
            return this.loading;
        },

        async saveVisibles() {
            if (!this.hasAccess('onoffaccessTable')) {
                return;
            }
            // Optimise, no need to save children if parent is true
            const removeTrueParentChildren = (tree, selected) => {
                let reducedSelected = JSON.parse(JSON.stringify(selected));
                selected.forEach((s) => {
                    // If this item has already been removed, ignore it
                    if (reducedSelected.includes(s)) {
                        const filter = (node) => {
                            return node.vpath === s;
                        };

                        const parentNode = treeUtils.findFirstTreeNode(
                            tree,
                            'children',
                            'children',
                            filter
                        );
                        if (parentNode) {
                            let remove = treeUtils.flattenTreeField(
                                parentNode,
                                'vpath',
                                'children',
                                []
                            );
                            remove = remove.filter(node => node !== s);
                            reducedSelected = reducedSelected.filter((rs) => {
                                return !remove.includes(rs);
                            });
                        }
                    }
                });
                return reducedSelected;
            };


            if (this.isAllowedTo(4) ||
                this.isAllowedTo(3) ||
                this.isAllowedTo(2)) {
                this.setLoading(true);
                // FIXME: use setMultipleInvisible instead
                await content.setTOCVisible(this.moduleId, this.toc[0].vpath,
                    removeTrueParentChildren(this.toc[0], this.selected));
                // await content.setMultipleVisible(this.moduleId, this.toc[0].vpath,
                //     removeTrueParentChildren(this.toc[0], this.selected));
                this.setLoading(false);
            }
        },

        setActiveItem(activePath, lineage) {
            this.active = [activePath];
            lineage.forEach((l) => {
                // Parent skip method
                // if (!this.open.includes(l) && l.includes('_PARENT')) { this.open.push(l); }
                if (!this.open.includes(l)) { this.open.push(l); }
            });
        },

        cleanActiveClass() {
            const allActiveNodes = document.querySelectorAll('.v-treeview-node--active');
            for (let i = 0; i < allActiveNodes.length; i++) {
                const activeNode = allActiveNodes[i];
                activeNode.className = activeNode.className.replace(`v-treeview-node--active`, ``);
            }
        },

        updateTree(moduleId, pagePath) {
            if (moduleId !== undefined && pagePath !== undefined) {
                const { lineage } = this.navigation[moduleId][pagePath];
                this.setActiveItem(
                    pagePath,
                    lineage.map(item => item.path)
                );
            }
        },

        initExpandTwoLevels() {
            if (this.toc && this.toc.length > 0) {
                this.getTwoLevels(this.toc);
            }
        },

        getTwoLevels(toc) {
            toc.forEach((t) => {
                if (t) {
                    if (t.level === 0 || t.level === 1) {
                        this.open.push(t.path);
                    }

                    if (t.children && t.children.length > 0) {
                        this.getTwoLevels(t.children);
                    }
                }
            });
        }
    }
};
</script>

<style>
.v-treeview-node {
  padding-top: 5px;
  margin-left: 15px;
}
.v-treeview-node__label {
  display: none;
  font-size: 0.89rem;
  flex-shrink: 1;
}
.v-treeview-node--leaf {
  padding-left: 14px;
  margin-left: 25px;
}

/*
.v-treeview-node__root {
  border-right: 5px solid #9ea5a3;
}*/

.v-treeview-node__content {
  padding-top: 5px;
  flex-shrink: 1;
}

.v-treeview-node--active{
  background-color:transparent !important;
}

.v-treeview-node--active .v-treeview-node__root {
  margin-left: -1px !important;
  border-left: 1px solid var(--v-secondary-base);
  border-right: 5px solid var(--v-secondary-base);
  background-color: #EEEDE9;
  border-top: 1px solid rgba(0,0,0,0.12);
  border-bottom: 1px solid rgba(0,0,0,0.12);
}

.imsuperselected {
  margin-left: -1px !important;
  border-left: 1px solid var(--v-secondary-base);
  border-right: 5px solid var(--v-secondary-base);
  background-color: #EEEDE9;
  border-top: 1px solid rgba(0,0,0,0.12);
  border-bottom: 1px solid rgba(0,0,0,0.12);
}


.v-treeview-node--active .v-treeview-node__children .v-treeview-node__root {
  padding-top: 5px;
  color: rgba(0,0,0,0.87);
  border-right: none;
  border-left: none;
  background-color: #f8fbfe !important;
  border-top: none;
  border-bottom: none;
}

.v-icon.accent--text{
  color: var(--v-secondary-base) !important;
}

.v-icon--link {
  color: var(--v-secondary-base) !important;
}

.text-link {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/content/CEModuleTOC.vue